import React, { useState } from 'react';
import '../styles/ComingSoon.css';
import logo from '../logo.svg';
import bgpic from '../bgpic.png';

function ComingSoon() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Connect to email service (SendGrid, Firebase, etc.)
    console.log('Form submitted:', formData);
    alert(`Thank you, ${formData.name}! We'll be in touch at ${formData.email} soon.`);
    setFormData({ name: '', email: '', phone: '', message: '' });
    setShowForm(false);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="coming-soon-wrapper" style={{ backgroundImage: `linear-gradient(135deg, rgba(248, 249, 250, 0.85), rgba(255, 255, 255, 0.85), rgba(240, 242, 245, 0.85)), url(${bgpic})` }}>
      <div className="coming-soon-container">
        {/* Logo */}
        <div className="logo-section">
          <img src={logo} alt="TrueVine Nursing" className="logo-image-main" />
        </div>

        {/* Main Content */}
        <div className="content-section">
          <h1 className="main-headline">Recovery, Reimagined.</h1>
          
          <p className="location-info">
            Hospital-level nursing care in the comfort of your own home.<br />
            Serving Frisco, Plano, and North Texas.
          </p>

          <p className="description">
            You shouldn't have to recover alone. TrueVine Nursing provides private, concierge RN support for post-operative care and cosmetic recovery. No waiting rooms. No shift changes. Just you and your dedicated nurse.
          </p>

          {/* Coming Soon Label */}
          <div className="coming-soon-label">
            Coming Soon
          </div>
        </div>

        {/* Footer */}
        <div className="footer-section">
          <p>TrueVine Nursing Serving DFW & North Texas.</p>
        </div>
      </div>

      {/* Contact Form Modal */}
      {showForm && (
        <div className="form-overlay" onClick={handleCloseForm}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={handleCloseForm}>×</button>
            <h2>Get in Touch</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Your name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="your@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="(555) 123-4567"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  placeholder="Tell us about your needs..."
                  rows="4"
                />
              </div>

              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default ComingSoon;
